import { type ZodObject, type ZodTypeAny, z } from "zod";

/**
 * Creates a zod object with the given keys and the given base type
 * @param keys - array of strings to use as keys in the resulting object
 * @param baseType - zod type to use for all keys
 * @returns a zod object with the given keys and the given base type
 *
 * @example
 * const schema = createDynamicSchema(['a', 'b'], z.string());
 */
export default function createDynamicSchema<
	T extends readonly string[],
	Base extends ZodTypeAny,
>(keys: T, baseType: Base): ZodObject<{ [K in T[number]]: Base }> {
	const shape = keys.reduce(
		(acc, key) => {
			acc[key as T[number]] = baseType;
			return acc;
		},
		{} as { [K in T[number]]: Base },
	);

	return z.object(shape);
}
